import React, {Component, PropTypes} from 'react';
import {connect} from 'react-redux';
import DatePicker from 'react-date-picker';
import moment from 'moment-timezone';
import {changeToTrial} from '../../actions/ClientActions';
import Modal from '../Modal';

@connect(
    state => ({
        isSavingChangeToTrial: state.modal.isSavingChangeToTrial
    })
)
export default class ChangeToTrialModal extends Component {

    static propTypes = {
        client: PropTypes.shape({
            id: PropTypes.string.isRequired,
        }),
    }

    constructor(props){
        super(props);

        this.state = {
            trialEnds: moment().add(1,'days'),
            datePickerVisible : false,
            useSelectedDate: true,
        }
    }

    changeToTrial = () => {

        const { currentPlan, lastPlan } = this.props.client;
        const planTrialMap = new Map([
            ['Free', 'Trial'],
            ['Basic', 'Trial'],
            ['Professional', 'Trial'],
            ['Essentials', 'Essentials-Trial'],
            ['Pro', 'Pro-Trial'],
            ['Essentials-Trial', 'Essentials-Trial'],
            ['Pro-Trial', 'Essentials-Trial'],

        ]);

        // 1. currentPlan not empty -> switch to corresponding Trial using currentPlan
        // 2. currentPlan empty & lastPlan not empty -> extend to corresponding Essentials/Pro Trial using lastPlan (from Essentials/Pro Trial)
        // 3. otherwise switch to Legacy Trial
        const plan = currentPlan || lastPlan
        const planName = plan  ? planTrialMap.get(plan.label) || 'Trial' : 'Trial';

        return this.props.dispatch(
            changeToTrial(
                {
                    clientId : this.props.client.id,
                    ...(this.state.useSelectedDate ? {trialEnd: this.state.trialEnds} : {}),
                    planName: planName
                }
            )
        )
    }

    handleDateChange = (newDate) => {
        this.setState({trialEnds: newDate});
    };

    render() {
        var actionButton = this.props.isSavingChangeToTrial ?
            (<button className='btn btn-success disabled'>Changing to Trial...</button>) :
            (<button className='btn btn-success' onClick={this.changeToTrial}>Change to Trial</button>);

        return (
            <Modal
                actionButton={actionButton}
                className='modal modal-success'
                title='Change Client to Trial'>
                    <div>
                        <p>This will change the Client to a Trial.
                            <br />
                            <br />
                            This will cause any plan/add-ons they have selected to be <b>stopped</b>,
                            and any pending plan/add-on changes will be <b>cancelled</b>.
                        </p>
                        <div style={{
                            margin: '3rem auto 3rem auto',
                            textAlign: 'center',
                            maxWidth: '50%',
                        }}>
                            {this.state.useSelectedDate ?
                                <div>
                                    <DateSelector
                                        trialEnds={this.state.trialEnds}
                                        onDateChange={this.handleDateChange}
                                    />
                                    <button
                                        className='btn btn-info'
                                        onClick={() => this.setState({useSelectedDate: false})}
                                    >
                                        Use default length instead
                                    </button>
                                </div> :
                                <div>
                                    <p>Trial will end in <b>14 days</b></p>
                                    <button
                                        className='btn btn-info'
                                        onClick={() => this.setState({useSelectedDate: true})}
                                    >
                                        Choose a date instead
                                    </button>
                                </div>
                            }
                        </div>
                    </div>
            </Modal>
        );
    }
}

class DateSelector extends Component {

    static propTypes = {
        trialEnds: PropTypes.object.isRequired,
        onDateChange: PropTypes.func.isRequired,
    };

    state = {
        datePickerVisible: false,
    };

    dateClick = (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.setState({
            datePickerVisible : ! this.state.datePickerVisible
        });
    }

    blurDate = (e) => {
        e.preventDefault();
        this.setState({
            datePickerVisible : false
        })
    }

    dateChange = (dateString, moment) => {
        this.setState({
            datePickerVisible : false
        });

        this.props.onDateChange(moment);
    }

    render() {
        const tomorrow = moment().add(1,'days').format('YYYY-MM-DD');
        return (
            <form onSubmit={e => e.preventDefault()} style={{marginBottom: '8px'}}>
                <label htmlFor='trialEnd' style={{marginRight: '1rem'}}>Trial will end at</label>
                <input
                    name='trialEnd'
                    type='text'
                    style={{cursor: 'pointer', textAlign: 'center'}}
                    readOnly
                    value={this.props.trialEnds.format('DD/MM/YYYY')}
                    onClick={this.dateClick}
                />

                {this.state.datePickerVisible &&
                    <div>
                        <a onClick={this.onCancel} href='#'>Cancel</a>
                        <DatePicker
                            minDate={tomorrow}
                            date={tomorrow}
                            onChange={this.dateChange}
                        />
                    </div>
                }
            </form>
        );
    }
}



// WEBPACK FOOTER //
// ./app/components/clients/ChangeToTrialModal.js